import React, { Component } from 'react';
import {
  Create,
  TextInput,
  ReferenceInput,
  SelectInput,
  TabbedForm,
  FormTab,
  ImageInput,
  ImageField,
  DateInput,
  LongTextInput,
  required,
} from 'react-admin';
import Title from './Title';
import { withStyles } from '@material-ui/core/styles';
import UploadToolbar from 'components/UploadToolbar';
import PictureNote from 'components/PictureNote';

const styles = {
  root: {
    marginTop: '24px',
  },
};

const customValidation = values => {
  const errors = {};
  if (values.contact_mobile && !values.contact_mobile.startsWith('+')) {
    errors.contact_mobile = ['Mobile should start with +'];
  }
  if (values.started_at > values.ended_at) {
    errors.ended_at = ['Ended Date must be greater than Started Date'];
  }
  return errors;
};

class CreateForm extends Component {
  state = {
    carBrandID: '',
  };

  handleChangeCarBrand = (e, value) => {
    this.setState({ carBrandID: value });
  };

  renderContainer() {
    const { classes, ...rest } = this.props;
    const { carBrandID } = this.state;
    return (
      <Create title={<Title />} {...rest}>
        <TabbedForm validate={customValidation} toolbar={<UploadToolbar source={['cover_url']} />}>
          <FormTab label="General">
            <ReferenceInput
              label="Car Brand"
              source="car_brand_id"
              reference="brands"
              onChange={this.handleChangeCarBrand}
              perPage={-1}
              validate={required()}
            >
              <SelectInput optionText="name" />
            </ReferenceInput>
            {carBrandID && (
              <ReferenceInput
                label="Car Model"
                source="car_model_id"
                reference="models"
                emptyValue={0}
                filter={{ car_brand_id: carBrandID }}
                perPage={-1}
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
            )}
            <ImageInput source="qcover_url" label="Cover Image" accept="image/jpeg,image/png" validate={required()}>
              <ImageField source="src" title="title" />
            </ImageInput>
            <PictureNote width="400" height="600" />
            <TextInput source="title" fullWidth={true} validate={required()} />
            <LongTextInput source="description" validate={required()} />
          </FormTab>
          <FormTab label="Extra Info">
            <DateInput source="started_at" validate={required()} label="Start Date" />
            <DateInput source="ended_at" validate={required()} label="End Date" />
            <TextInput source="contact_mobile" validate={required()} />
            <TextInput source="contact_email" type="email" validate={required()} />
          </FormTab>
        </TabbedForm>
      </Create>
    );
  }

  render() {
    return this.renderContainer();
  }
}

export default withStyles(styles)(CreateForm);



// WEBPACK FOOTER //
// ./src/containers/Promotion/CreateForm.js